import React from 'react';
import { Button } from '@mui/material';
import html2pdf from 'html2pdf.js';

interface PdfExportButtonProps {
  targetElement: HTMLElement;
  filename?: string;
  className?: string;
  disabled?: boolean;
  debug?: boolean;
}

const PdfExportButton: React.FC<PdfExportButtonProps> = ({
  targetElement,
  filename = 'label.pdf',
  className = 'html2pdf',
  disabled = false,
  debug = false,
}) => {
  const handleExport = () => {
    if (!targetElement) return;

    targetElement.classList.add(className);

    if (debug) {
      const clone = targetElement.cloneNode(true) as HTMLElement;
      document.body.appendChild(clone);
    }

    html2pdf()
      .set({
        margin: 0.5,
        filename,
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      })
      .from(targetElement)
      .save()
      .finally(() => {
        targetElement.classList.remove(className);
      });
  };

  return (
    <Button variant="outlined" onClick={handleExport} disabled={disabled}>
      PDF
    </Button>
  );
};

export default PdfExportButton;
